import {ref, Ref} from '@vue/composition-api';

export type EditorDialogPromptSaveCallback = (new_val: string | null) => void;
export interface EditorDialogPromptShowOptions {
	title: string;
	default_value: string;
	confirm_label: string;
	multiline?: boolean;
}

export class EditorDialogPromptStoreControllerClass {
	private static _instance: EditorDialogPromptStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogPromptStoreControllerClass());
	}

	private _displayed!: Ref<boolean>;
	private _title!: Ref<string>;
	private _multiline!: Ref<boolean>;
	private _default_value!: Ref<string>;
	private _confirm_label!: Ref<string>;
	private _on_save_callback: EditorDialogPromptSaveCallback | undefined;
	private constructor() {}

	init() {
		this._displayed = ref(false);
		this._title = ref('');
		this._multiline = ref(false);
		this._default_value = ref('');
		this._confirm_label = ref('ok');
	}

	// getters
	displayed(): boolean {
		return this._displayed.value;
	}
	title(): string {
		return this._title.value;
	}
	multiline(): boolean {
		return this._multiline.value;
	}
	default_value(): string {
		return this._default_value.value;
	}
	confirm_label(): string {
		return this._confirm_label.value;
	}
	execute_on_save_callback(value: string | null) {
		if (this._on_save_callback) {
			const callback = this._on_save_callback;
			this._on_save_callback = undefined;
			callback(value);
		}
	}

	// mutations
	async show(options: EditorDialogPromptShowOptions): Promise<string | null> {
		return new Promise((resolve, reject) => {
			this._displayed.value = true;
			this._title.value = options.title;
			this._multiline.value = options.multiline || false;
			this._confirm_label.value = options.confirm_label;
			this._default_value.value = options.default_value;
			this._on_save_callback = resolve;
		});
	}
	hide() {
		this._displayed.value = false;
		this.execute_on_save_callback(null);
	}
}

export const EditorDialogPromptStoreController = EditorDialogPromptStoreControllerClass.instance();
